import Lang from '@lang/en';

export interface CustomErrorResponseInterface extends Error {
  data: Record<string, unknown>;
}

export interface CustomErrorCallInterface extends Error {
  response: CustomErrorResponseInterface;
}

export const getErrorMessage = (error: CustomErrorCallInterface): string => {
  if (!error.response || !error.response.data) {
    return Lang.unknownError;
  }

  const allErrors = Object.values(error.response.data).flatMap(
    (errors) => errors
  );

  return allErrors.join('\n');
};
